import {toast} from 'sonner';

export const showDefaultRequestErrorToast = () => {
  toast.error('Request failed', {
    description: `We’re unable to process your request right now. Please try again.`,
  });
};
